import React, {PureComponent} from 'react';
import DayAvailability from './DayAvailability';

const createDayAvailability = (WrappedComponent, enableSameDayAvailability) =>
    class extends PureComponent {
        static canClick = (args) =>
            WrappedComponent.canClick({enableSameDayAvailability, ...args});
        static canHover = (args) =>
            WrappedComponent.canHover({enableSameDayAvailability, ...args});

        render() {
            return (
                <WrappedComponent
                    enableSameDayAvailability={enableSameDayAvailability}
                    {...this.props}
                />
            );
        }
    };

export const DefaultDayAvailability = createDayAvailability(
    DayAvailability,
    false
);
export const SameDayAvailability = createDayAvailability(DayAvailability, true);
